/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Livid_Round_Impala_FindInputs */

const fr_livid_round_impala_find = /** @type {(inputs: Livid_Round_Impala_FindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrondi`)
};

/**

* @param {Livid_Round_Impala_FindInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const livid_round_impala_find = /** @type {((inputs?: Livid_Round_Impala_FindInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Livid_Round_Impala_FindInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_livid_round_impala_find(inputs)
});